import React, { useEffect, useState } from 'react'
import { Modal, Input, Checkbox } from 'antd'
import { inr } from './helpers'
import { voucherValue } from './QueueList'

// Confirm step for both bulk paths:
//  mode 'selected' - the vouchers ticked in the queue (max 200, synchronous)
//  mode 'filter'   - every eligible voucher matching the current filters,
//                    run on the server as one background batch (backlog catch-up)
// Either way the result is logged as a BULK batch, never as individual audits.
const BulkDialog = ({ visible, mode, items, filterCount, filterText, busy, onCancel, onConfirm }) => {
  const [remarks, setRemarks] = useState('')
  const [ack, setAck] = useState(false)
  useEffect(() => { if (visible) { setRemarks(''); setAck(false) } }, [visible])

  const n = mode === 'filter' ? filterCount : items.length
  const nPI = mode === 'filter' ? null : items.filter(i => i.voucherType === 'PI').length
  const value = mode === 'filter' ? null : items.reduce((s, i) => s + voucherValue(i).sum, 0)
  const ok = remarks.trim().length > 0 && ack && n > 0

  return (
    <Modal
      visible={visible}
      wrapClassName='sax-modal'
      title={'Bulk audit ' + n + ' voucher' + (n === 1 ? '' : 's')}
      okText={'Audit ' + n}
      okButtonProps={{ disabled: !ok, loading: !!busy }}
      cancelButtonProps={{ disabled: !!busy }}
      onOk={() => onConfirm(remarks.trim())}
      onCancel={busy ? undefined : onCancel}
      maskClosable={!busy}
      destroyOnClose
    >
      {mode === 'filter'
        ? (
          <div className='sum' style={{ gridTemplateColumns: '1fr 2fr' }}>
            <div><b>{n}</b><span>New vouchers with no checks</span></div>
            <div><b style={{ fontSize: 13, fontFamily: 'inherit' }}>{filterText}</b><span>Filters in force</span></div>
          </div>)
        : (
          <div className='sum'>
            <div><b>{nPI}</b><span>Purchases (PI)</span></div>
            <div><b>{n - nPI}</b><span>Issues (SPI)</span></div>
            <div><b>{inr(Math.round(value))}</b><span>Value</span></div>
          </div>)}

      <div className='skip'>
        Only new vouchers with no checks are included. Vouchers with checks, open queries or edits since their audit
        must be audited one by one.
        {mode === 'filter' && ' If the number of eligible vouchers changes before the server starts, nothing is audited and you are asked to review again.'}
      </div>

      <div className='logn'>
        This is logged as a <b>bulk audit</b> under one batch number, with your name and this remark.
        Every voucher's history will show it was audited in bulk, not individually.
        {mode === 'filter' && ' It runs on the server; you can keep working while it does.'}
      </div>

      <label className='lbl' htmlFor='sax-bulk-remark'>Remark (required)</label>
      <Input.TextArea id='sax-bulk-remark' rows={3} value={remarks} onChange={e => setRemarks(e.target.value)}
        placeholder='What did you check before auditing these together?' disabled={!!busy} />
      <div style={{ marginTop: 10 }}>
        <Checkbox checked={ack} onChange={e => setAck(e.target.checked)} disabled={!!busy}>
          I accept these {n} vouchers as entered.
        </Checkbox>
      </div>
    </Modal>
  )
}

export default BulkDialog
